import React, { useRef } from "react";
import styles from "./Board.module.css";
import CanvasWrapper from "../CanvasWrapper";
import useCanvasFill from "./useCanvasFill";
import ContextMenu from "./ContextMenu/ContextMenu";
import { useCanvas } from "../../context/canvasContext";

/** The board card filling the area below the header; the canvas is the whole card. */
const Board = ({ contentLoading, setContentLoading }) => {
  const cardRef = useRef(null);
  const { canvasRef } = useCanvas();
  useCanvasFill(canvasRef, cardRef, !contentLoading);

  return (
    <div className={styles.card} ref={cardRef}>
      <CanvasWrapper contentLoading={contentLoading} setContentLoading={setContentLoading} />
      <ContextMenu />
    </div>
  );
};

export default Board;
